var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner",attrs:{"id":"banner"}},[(_vm.bys == 'swipe')?_c('Swiper',{attrs:{"slide":_vm.banner,"swiperParam":_vm.sp,"isBack":1}}):_c('div',{staticClass:"pbi_wrapper"},[_vm._t("pinb")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d031866e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Banner.vue
// module id = null
// module chunks = 